import { PlusOutlined } from '@ant-design/icons';
import { AppButton } from 'shared/UI/UIKit/Button';
import { AppModal } from 'shared/UI/UIKit/Modal';
import { AppFlex } from 'shared/UI/UIKit/Flex';
import { MaxLessonsPerDayForm } from 'entities/max-lessons-per-day';
import { useMaxLessonsPerDayCreate } from '../model';

interface MaxLessonsPerDayCreateProps {
  refreshTable: () => void;
}

export const MaxLessonsPerDayCreate = ({ refreshTable }: MaxLessonsPerDayCreateProps) => {
  const {
    state: { modalVisible, form },
    methods: { showModal, hideModal, onSubmit },
  } = useMaxLessonsPerDayCreate({ refreshTable });

  return (
    <>
      <AppButton
        type="primary"
        icon={<PlusOutlined />}
        onClick={showModal}
        style={{ alignSelf: 'flex-end', width: 'fit-content' }}
      >
        Создать конфигурацию
      </AppButton>

      <AppModal
        title="Новая конфигурация"
        visible={modalVisible}
        onCancel={hideModal}
        content={<MaxLessonsPerDayForm form={form} />}
        destroyOnClose
        footer={
          <AppFlex direction="row">
            <AppButton type="primary" onClick={onSubmit}>
              Создать
            </AppButton>
            <AppButton type="outline" onClick={hideModal}>
              Закрыть
            </AppButton>
          </AppFlex>
        }
      />
    </>
  );
};
